import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TicketListComponent } from './ticket-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { TicketService } from './ticket.service';

@Component({
    selector: 'convfact-ticketdelete',
    templateUrl: './ticket-dialog-delete.component.html',
    styleUrls: ['./ticket.component.css'],
    standalone: false
})
export class TicketDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    error_msg: string;
    error: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<TicketListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public ticketService: TicketService
    ) { }

    delete() {
        this.ticketService.deleteData(this.uid);
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }
}